<template>
  <div class="footer">
    <div class="content">
      <div class="contact-list">
        <div class="title">服务支持</div>
        <div class="contact">
          <!--<a
            class="conctact-desc"
            href="dingtalk://dingtalkclient/action/sendmsg?dingtalk_id=12m_3ft3w474kh"
          >-->
            <img src="@/assets/icon/lark-s.png" width="16" />人力 飞书联系「HR服务台」
          <!--</a>-->
        </div>
        <div class="contact">
         <!-- <a
            class="conctact-desc"
            href="dingtalk://dingtalkclient/action/sendmsg?dingtalk_id=13f-stehmou9pg"
          >-->
            <img src="@/assets/icon/lark-s.png" width="16" />行政 飞书联系「行政小客服」
          <!--</a>-->
        </div>

        <!--<div class="contact">
          <img src="@/assets/icon/dianhua.png" width="16" height="16" />财务报销咨询热线 4008177000
        </div>-->
        <div class="contact" id="it-support">
          <img src="@/assets/icon/shubiao.png" width="16" />IT支持飞书群
          <img src="@/assets/img/it-support-feishu.png" width="120" alt id="support" />
        </div>
      </div>
      <div class="qr-code-list">
        <div class="qr-code-item">
          <div>
            <img src="@/assets/img/sike.png" width="113" alt />
          </div>思嗑6点6
        </div>
        <div class="qr-code-item">
          <div>
            <img src="@/assets/img/weibo.png" width="113" alt />
          </div>美菜微博
        </div>
        <div class="qr-code-item">
          <div>
            <img src="@/assets/img/shangcheng.png" width="113" alt />
          </div>微信商城
        </div>
      </div>
    </div>

    <div class="copyright">云杉林技术支持 效能与质量中心</div>
  </div>
</template>
<script>
export default {
  data() {
    return {

    };
  },
  created() {
  },
  methods: {

  }
};
</script>
<style lang="scss" scoped>
.footer {
  background: #f6f6f6;
  margin-top: 100px;
  .content {
    width: 1200px;
    margin: 0 auto;
    padding: 60px 0;
    display: flex;
    justify-content: space-between;
    .contact-list {
      color: #909399;
      a {
        color: #909399;
      }
      a:hover {
        color: #1890ff !important;
      }
    }
    .qr-code-list {
      width: 600px;
      display: flex;
      justify-content: space-between;
      .qr-code-item {
        img {
          margin-bottom: 14px;
        }
        color: #606266;
        text-align: center;
      }
    }
    .title {
      height: 25px;
      line-height: 25px;
      font-family: PingFangSC-Medium;
      font-size: 18px;
      color: #606266;
      margin-bottom: 20px;
    }
    .contact {
      height: 20px;
      line-height: 20px;
      margin: 8px 0;
      cursor: pointer;
      &:hover {
        color: #1890ff !important;
      }
      img {
        vertical-align: -15%;
        margin-right: 12px;
      }
    }
    #it-support {
      #support {
        display: none;
        vertical-align: top;
      }
      &:hover {
        text-decoration: underline;
      }
      &:hover #support {
        display: inline-block;
      }
    }
  }
  .copyright {
    width: 1200px;
    height: 70px;
    margin: 0 auto;
    color: #909399;
    line-height: 60px;
    text-align: center;
    box-shadow: inset 0 1px 0 0 #c0c4cc;
  }
}
</style>
